export default "/images/co-img-6.png?ed0ce2b0bae835cf05f9daffcf90f6eb";